module.exports = __webpack_public_path__ + "static/cherry.50f70f93.jpg";